/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import * as WidgetUtil from '../../../utils/widgetUtil'
import ContentType from '../../../enums/ContentType'
import { getContentType } from '../../../utils/analysisTypeUtil'
import AnalysisType from '../../../enums/AnalysisType'
// TODO: add nb.ui.Widget methods as utils here

/**
 * @return {Array.<nb.dto.TopicInfo>}
 */
export function getSearchTopics(setting) {
  return WidgetUtil.getSearchTopics(setting)
}

/**
 * @param {AnalysisTypeStrings} analysisType
 * @return {boolean}
 */
export function isAudienceAnalysis(analysisType) {
  return ContentType.AUDIENCE_MARKETING === getContentType(analysisType)
}

/**
 * @param {AnalysisTypeStrings} analysisType
 * @return {boolean}
 */
export function isYoutubeOnly(analysisType) {
  return analysisType === AnalysisType.YT_SUMMARY
}
